<template>
	<div class="playerBoxComponent">

		<div class="nameContainer">
			<div v-if="editingName">
				<b-form @submit.prevent="toggleNameEdit">
					<b-input-group>
						<b-form-input :value="name" @input="handleNameChange"/>
						<b-input-group-append>
							<b-button type="submit">
								<fa icon="check"/>
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-form>
			</div>
			<div v-else class="name" @click="toggleNameEdit">{{name}}</div>
		</div>

		<div class="box">
			<fa v-if="icon" class="icon" :class="iconClass" :icon="icon"/>
			<div class="score" v-else>{{score}}</div>
		</div>

		<Instructions :name="name" :keyMap="keyMap"/>

	</div>
</template>

<script>

  import Instructions from "./Instructions";

  export default {
    components: {Instructions},
    data() {
      return {
        editingName: false,
      };
    },
    props: {
      name: {type: String, required: true},
      keyMap: {type: Object, required: true},
      icon: {type: String, default: null},
      win: {type: Boolean, default: null},
      score: {type: Number, default: 0},
    },
    computed: {
      iconClass() {
        if (this.win === null) return 'neutral';
        return this.win ? 'win' : 'lose';
      }
    },
    methods: {
      toggleNameEdit() {
        this.editingName = !this.editingName;
      },
      handleNameChange(value) {
        this.$emit('nameChange', value);
      },
    },
  };

</script>

<style scoped>
	.playerBoxComponent {
		width: 300px;
	}

	.nameContainer {
		height: 50px;
	}

	.name {
		font-weight: bold;
		text-align: center;
		text-transform: uppercase;
		font-size: 20px;
		margin-right: 15px;
		cursor: pointer;
	}

	.box {
		overflow: hidden;
		box-sizing: border-box;
		width: 300px;
		height: 300px;
		border: 5px solid #000;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.score {
		font-size: 250px;
	}

	.icon {
		width: 80%;
		height: 80%;
	}

	.icon.win {
		color: #080;
	}

	.icon.lose {
		color: #800;
	}
</style>
